import { RouteObject } from "react-router-dom"
import AuthGuard from "../../../shared/auth/component/auth"
import NewSaleComponent from "../component/new-sale-component"
import SalePage from "../page/sale.page"
export const SaleRoute: RouteObject = {
  path: "/sale",
  element: (
    <AuthGuard role={["super_admin", "owner"]} permission={["manage-tenants", "view-tenants"]}>
      <SalePage />
    </AuthGuard>
  ),
  children: [
    {
      path: "detail/:type/:id",
      element: <NewSaleComponent editMode="detail" />,
    },
    { path: ":id", element: <NewSaleComponent editMode="new" /> },
  ],
}
